/* La Thé Box — en-tête et méga-menu.
   Passation : _design/boutique/07-menu/

   Deux comportements, un seul jeu de panneaux :

   - **desktop** : survol d'une entrée, ouverture après un court délai,
     fermeture différée. Les deux délais ne sont pas du confort : sans le
     premier, traverser la barre en diagonale ouvre trois panneaux au passage ;
     sans le second, le trajet de l'entrée vers le panneau referme tout au
     moment où la souris quitte le lien ;
   - **mobile** : tiroir plein écran, un accordéon par entrée.

   Rien ici n'est nécessaire à la navigation. Sans JavaScript, les quatre
   entrées restent des liens vers leurs pages et les panneaux restent fermés :
   c'est pour cela qu'elles sont des `<a>` et non des `<button>`. */
(() => {
  const entete = document.querySelector('[data-ltb-hdr]');
  if (!entete) return;

  const panneaux = entete.querySelector('[data-ltb-panneaux]');
  const voile = document.querySelector('[data-ltb-voile]');
  const entrees = [...entete.querySelectorAll('[data-ltb-entree]')];
  const accordeons = [...entete.querySelectorAll('[data-ltb-accordeon]')];
  const burger = entete.querySelector('[data-ltb-burger]');
  if (!panneaux) return;

  const DELAI_OUVERTURE = 120;
  const DELAI_FERMETURE = 220;

  const bureau = () => window.matchMedia('(min-width: 990px)').matches;
  const panneauDe = (cle) => panneaux.querySelector(`[data-ltb-panneau="${cle}"]`);

  let minuterie = null;
  let ouvert = null;

  const annuler = () => {
    if (minuterie) {
      clearTimeout(minuterie);
      minuterie = null;
    }
  };

  /* -------- Desktop : les panneaux déroulants -------- */

  function ouvrir(cle) {
    if (ouvert === cle) return;
    fermer();
    const panneau = panneauDe(cle);
    if (!panneau) return;
    panneau.hidden = false;
    const entree = entrees.find((e) => e.dataset.ltbEntree === cle);
    if (entree) entree.setAttribute('aria-expanded', 'true');
    if (voile) voile.hidden = false;
    ouvert = cle;
  }

  function fermer() {
    if (!ouvert) return;
    const panneau = panneauDe(ouvert);
    if (panneau) panneau.hidden = true;
    const entree = entrees.find((e) => e.dataset.ltbEntree === ouvert);
    if (entree) entree.setAttribute('aria-expanded', 'false');
    if (voile) voile.hidden = true;
    ouvert = null;
  }

  entrees.forEach((entree) => {
    const cle = entree.dataset.ltbEntree;

    entree.addEventListener('mouseenter', () => {
      if (!bureau()) return;
      annuler();
      minuterie = setTimeout(() => ouvrir(cle), DELAI_OUVERTURE);
    });

    // Le clavier n'a pas de survol : le focus ouvre, mais sans délai — il n'y
    // a pas de trajectoire à tolérer.
    entree.addEventListener('focus', () => {
      if (!bureau()) return;
      annuler();
      ouvrir(cle);
    });
  });

  // La fermeture s'arme à la sortie de l'en-tête entier — barre et panneaux
  // réunis —, jamais à la sortie d'une entrée : entre les deux il y a le vide
  // que la souris traverse.
  entete.addEventListener('mouseleave', () => {
    if (!bureau()) return;
    annuler();
    minuterie = setTimeout(fermer, DELAI_FERMETURE);
  });

  entete.addEventListener('mouseenter', () => {
    if (!bureau()) return;
    annuler();
  });

  if (voile) voile.addEventListener('click', fermer);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (ouvert) {
      const entree = entrees.find((el) => el.dataset.ltbEntree === ouvert);
      fermer();
      if (entree) entree.focus();
    } else if (entete.dataset.ltbTiroir === 'ouvert') {
      fermerTiroir();
      if (burger) burger.focus();
    }
  });

  // Le focus qui sort de l'en-tête ferme le panneau : au clavier, on ne laisse
  // pas un panneau ouvert derrière soi.
  document.addEventListener('focusin', (e) => {
    if (!bureau() || !ouvert) return;
    if (!entete.contains(e.target)) fermer();
  });

  /* -------- Mobile : le tiroir -------- */

  /* Le verrou de défilement sort le corps du flux et le décale de sa position.

     `overflow: hidden` seul ne suffit pas : Safari mobile recalcule alors les
     éléments **collants** de la page, qui reprennent leur place naturelle et
     se peignent par-dessus le tiroir. C'est ce qui faisait traverser les
     pastilles de filtre d'une page de collection au milieu du menu, constaté
     le 09/09/2026. Corps fixé, plus rien de la page ne bouge ni ne remonte.

     Le décalage est mémorisé et rendu à la fermeture, sinon le client revient
     en haut de la page qu'il était en train de lire. */
  let defilement = 0;

  // Le thème ramène l'en-tête escamoté dès qu'un menu est ouvert : c'est sa
  // règle `.shopify-section-header-hidden.menu-open { top: 0 }`. Sans elle, le
  // tiroir s'ouvrait sous une barre partie se cacher au défilement, et la page
  // restait visible dans la bande laissée libre.
  const groupe = document.querySelector('.section-header');

  function ouvrirTiroir() {
    entete.dataset.ltbTiroir = 'ouvert';
    if (burger) burger.setAttribute('aria-expanded', 'true');
    defilement = window.scrollY;
    document.body.style.top = `-${defilement}px`;
    document.body.classList.add('ltb-hdr-fige');
    if (groupe) groupe.classList.add('menu-open');
    caler();
  }

  function fermerTiroir() {
    delete entete.dataset.ltbTiroir;
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ltb-hdr-fige');
    document.body.style.top = '';
    if (groupe) groupe.classList.remove('menu-open');
    window.scrollTo(0, defilement);
  }

  if (burger) {
    burger.addEventListener('click', () => {
      if (entete.dataset.ltbTiroir === 'ouvert') fermerTiroir();
      else ouvrirTiroir();
    });
  }

  accordeons.forEach((bouton) => {
    bouton.addEventListener('click', () => {
      const panneau = panneauDe(bouton.dataset.ltbAccordeon);
      if (!panneau) return;
      const ouvre = panneau.hidden;
      // Un seul accordéon ouvert à la fois : quatre panneaux dépliés font une
      // page de trois mille pixels dans laquelle on ne retrouve plus la sortie.
      accordeons.forEach((autre) => {
        const p = panneauDe(autre.dataset.ltbAccordeon);
        if (p) p.hidden = true;
        autre.setAttribute('aria-expanded', 'false');
      });
      panneau.hidden = !ouvre;
      bouton.setAttribute('aria-expanded', ouvre ? 'true' : 'false');
    });
  });

  /* -------- La hauteur de la barre, mesurée -------- */

  // Le tiroir se pose sous la barre. Il est en `position: fixed`, donc calé
  // sur la fenêtre et non sur son parent : c'est le **bas** de la barre qu'il
  // faut mesurer, pas sa hauteur. Avec la hauteur, le bandeau d'annonce
  // au-dessus décalait tout et le tiroir recouvrait le logo — constaté au
  // rendu en 390.
  function caler() {
    const barre = entete.querySelector('.ltb-hdr__barre');
    if (!barre) return;
    const bas = Math.round(barre.getBoundingClientRect().bottom);
    if (bas > 0) entete.style.setProperty('--ltb-hdr-hauteur', `${bas}px`);
  }

  caler();
  window.addEventListener('resize', () => {
    caler();
    // Changer d'orientation ou passer le seuil laisse sinon un panneau ouvert
    // dans une mise en page qui ne l'attend plus.
    if (bureau()) fermerTiroir();
    else fermer();
  });

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(caler);
})();
